var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26 30H6a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h5.333v-1a2 2 0 0 1 2-2h5.334v-2a2 2 0 0 1 2-2H26a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2zM11.333 19H6v9h5.333zm7.334-3h-5.334v12h5.334zm2 12H26V12h-5.333v3zM18.986 5.622c-3.763 5.548-10.738 7.347-10.738 7.347a1 1 0 0 1-.496-1.938s6.642-1.683 9.889-7.014L15.674 4a1 1 0 0 1 .018-2l4.28.038a.998.998 0 0 1 .991.991L21 7.21a1 1 0 0 1-2 .018z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesReports);
export default __webpack_public_path__ + "static/media/sales-reports.0144ab214599e609829db1c8c217651c.svg";
export { ForwardRef as ReactComponent };